import { ApolloProvider } from '@apollo/client';

const withApolloProvider = (Component: any) => {
  const Provider = (props: any) => {
    // Dynamically import client and mockClient here
    const { client: actualClient, mockClient } = require('./client');
    const currentClient =
      typeof jest !== 'undefined' ? mockClient : actualClient;

    return (
      <ApolloProvider client={currentClient}>
        <Component {...props} />
      </ApolloProvider>
    );
  };

  Provider.displayName = `withApolloProvider(${Component.displayName ?? Component.name ?? 'Component'})`;
  return Provider;
};

export default withApolloProvider;
